<template>
	<div class="section-content">
		<div class="page-title">
			<div style="padding-top:2%;display:flex;justify-content:space-between;align-items:center;">
				<div>
					最新资讯
					<img src="../assets/images/home_TitleLine.png" />
				</div>
				<div style="width:50%;">
					<div style="display:flex;align-items:center;background:linear-gradient(to right, #F6F3EF,#FDEBD3);">
						<img src="../assets/images/notice.png" class="itemImg" />
						<el-carousel style="height:50px;line-height:50px;width:100%;" direction="vertical"
							indicator-position="none" :autoplay="true">
							<div style="display:flex;align-items:center;">
								<el-carousel-item v-for="item in systemMsg" :key="item.id">
									<div @click="gotoXB" style="display:flex;align-items:center;">
										<span class="itemTitle">{{item.note}}</span>
									</div>
								</el-carousel-item>
							</div>
						</el-carousel>
						<div style="display:flex;line-height:50px;">
							<span style="color:red;margin-right:10px;">·</span>
							<i class="el-icon-arrow-right"
								style="color:#ff7300;font-size:16px;line-height:50px;margin-right:20px;"></i>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div class="content-section" style="background:#fff;height:42%;">
			<div style="width:60%;height:100%;">
				<el-carousel style="height:100%;">

					<el-carousel-item v-for="(item, index) in zixunBannerList" v-if="index < 3" :key="index"
						style="height:100%;">

						<img @click="gotoZXDetail(item)" :src="item.carouselUrl" style="width:100%;height:100%;" />
					</el-carousel-item>
				</el-carousel>
			</div>

			<div style="width:39%;margin-top:1%;display: flex; flex-direction: column;">
				<div style="display:flex;    flex-direction: column;justify-content: space-between;flex:1">
					<div v-for="(item,index) in zixunList" @click="gotoZXDetail(item)"
						style="display: flex;flex-direction: row;align-items: center;height:3.6vw;">
						<el-image fit="cover" :src="item.shrinkImg"
							style="width:3.6vw;height:3.6vw;border-radius: 7px;"></el-image>
						<div style="font-size: 1.1vw;color:#000;margin-left:5px;text-align: left;">{{item.title}}
						</div>
					</div>
				</div>
				<div @click="gotoZX" style="font-size:1vw; cursor: pointer;
					color: #999;display: flex;flex-direction: row;
					align-items: center;justify-content: right; margin-bottom:1vw">
					查看更多
					<el-image :src="leftArrow"
						style="width:1vw;height:1vw;margin-right: 20px;margin-left:3px;" fit="contain"></el-image>
				</div>
			</div>
		</div>

		<div class="content-section" style="margin-top:1%;height:30%; overflow: hidden;
  cursor: grab;" @mousedown="startDrag" @mouseup="stopDrag" ref="scrollContainer">
			<!-- <div  style="display: inline-block;  white-space: nowrap;width:85vw;" :style="{ transform: `translateX(${offset}px)` }" id="ssView"  draggable="false"> -->
			<div  style="display: inline-block;  white-space: nowrap;width:85vw;overflow-x: auto;" id="ssView"  draggable="false" class="userScorll" > 
				<!-- <div ></div> -->
					<div onselectstart="return false"  draggable="false" v-for="(item,index) in zixunBannerList" v-if="index > 2"  :key="item.id"  @click="gotoZXDetail(item)" style=" width:32%;height:100%;background-color: #fff;display: inline-block;
  margin-right: 2%;">
						<el-image draggable="false" :src="item.carouselUrl" fit="cover"
							style="width:100%;height:80%;vertical-align:middle;display:block;"></el-image>
						<div draggable="false" onselectstart="return false"
							style="color:#000;font-size:1.3vw;margin-left: 10px;height:20%;display:flex;align-items:center;">
							{{item.name}}
						</div>
					</div>
				
			</div>
		</div>

		<!-- <div class="content-section" style="margin-top:1%;height:30%;">
			<div style="min-width:100%;display: flex;flex-direction: row;
		justify-content: space-between;overflow-x: true;">
				<div v-for="(item,index) in zixunBannerList" v-if="index > 2"  :key="item.id"
					style="width:32.5vw;background-color: #fff;height:100%;">
					<el-image :src="item.carouselUrl" fit="cover"
						style="width:100%;height:80%;vertical-align:middle;display:block;"></el-image>
					<div
						style="color:#000;font-size:16px;margin-left: 10px;height:20%;display:flex;align-items:center;">
						{{item.nickName}}
					</div>
				</div>
			</div>
		</div> -->

		<el-image class="content-section" fit="contain" :src="zxBot" > </el-image>





	</div>
</template>

<script>
	import {
		zxCarousel,
		signingNewList,
		findByCondition,
		salesRankWebSite,
		summaryList
	} from '@/api/webstation.js'

	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				startX: 0,
				offset: 0,
				dragging: false,
				zxBot: '',
				leftArrow: require("../assets/images/leftArrow.png"),
				systemMsg: [],
				zixunList: [],
				zixunBannerList: [],
				xibaoList: [

				],
				maxScorll:0
			}
		},
		mounted() {
			// 监听mousemove事件
			document.addEventListener('mousemove', this.doDrag);
			// 监听mouseup事件
			document.addEventListener('mouseup', this.stopDrag);
		},
		created() {

			this.getNewList()
			this.getzxCarousel()
			this.findByCondition()
			this.getsummaryList()
			// this.getsalesRankWebSite()
		},
		methods: {
			getsummaryList() {
				let that = this
				summaryList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '21'
				}).then(res => {
					if (res.code == 200) {
						 
						console.log('res.rows[0]: ', res.rows[0]);
						that.zxBot=  res.rows[0].showImg
					}
				})
			},
			startDrag(event) {
				this.dragging = true;
				this.startX = event.clientX;
			},
			stopDrag() {
				this.dragging = false;
			},
			doDrag(event) {
				if(this.maxScorll == 0)
				{
					this.maxScorll = document.getElementById("ssView").scrollWidth - document.getElementById("ssView").clientWidth
				}
			
				
				if (this.dragging) {
					const deltaX = event.clientX - this.startX;
					this.offset += deltaX;
					// this.offset = -this.of
					
					this.startX = event.clientX;
					if(this.offset < -this.maxScorll)
					{
						this.offset = -this.maxScorll
						// console.log('this.offset: ',this.offset);
					}
					
					else if(this.offset > 0)
					{
						this.offset = 0
					}
					document.getElementById("ssView").scrollLeft = -this.offset;
				}
			},
			findByCondition() {
				let that = this
				findByCondition({
					pageNum: 1,
					pageSize: 4,
					classifyId: 1,
					// merchantId
				}).then(res => {
					if (res.code == 200) {
						that.zixunList = res.rows
					}

				})
			},
			getzxCarousel() {

				let that = this
				zxCarousel({
					positionId: 2,
				}).then(res => {
					if (res.code == 200) {
						that.zixunBannerList = res.data
					}

				})
			},
			getNewList() {

				let that = this
				signingNewList({
					pageNum: 1,
					pageSize: 10,
				}).then(res => {
					if (res.code == 200) {
						that.systemMsg = res.rows
					}

				})
			},

			gotoZXDetail(data) {
				console.log('data: ', data);
				this.$router.push('/newsInfoDetail?articleId=' + (data.articleId || data.masterId))
			},
			gotoZX() {
				this.$router.push('/newsInformation')
			},
			gotoXB() {
				console.log("///");
				this.$router.push('/qiandanxibao')
			}
		}

	}
</script>

<style scoped>
	@import '../assets/home.css';

	.el-carousel__container {
		height: 100% !important;
	}
	
	 /*指示器按钮*/
	 /deep/ .el-carousel__button {
	 width: 10px;
	   height: 10px;
	   border: none;
	   border-radius: 50%;
	   background-color: rgba(0, 0, 0, 0.2);
	 }
	 /*指示器激活按钮*/
	 /deep/ .is-active .el-carousel__button {
	   background: #fff;
	 }
	
</style>


// WEBPACK FOOTER //
// src/components/home_two.vue